import { AttrRange } from "./useAttributeInstances";
import { SentenceRange } from "./useParagraphSentences";

export const useRelevantInstanceSentence = (
  sentenceRanges: SentenceRange[],
  relevantInstance: AttrRange
) => {
  // Given a list of sentence ranges and a relevant instance, return the sentence range that the relevant instance is in
  for (const sentenceRange of sentenceRanges) {
    if (
      relevantInstance.start >= sentenceRange.start &&
      relevantInstance.end <= sentenceRange.end
    ) {
      return sentenceRange;
    }
  }
  return undefined;
};
